

<div *ngIf="!isResetPassword && !isDeleteUser && !isConfirmAction" class="modal-dialog modal-dialog-centered" style="padding: 1rem 0;">
  <div class="modal-content justify-content-center">
    <div class="modal-body modal-password">
        <div class="user-profile" style="margin-top: 0 !important;">
            <img class="logo-img" src="assets/images/warning.png" alt="avatar">
        </div>
        <div class="add-contact-box">
            <div class="add-contact-content d-flex flex-column justify-content-center align-items-center">
                <h5 class="text-center" style="font-weight: 600;">{{ 'record.download.confirmation' | translate }}</h5>
                <h5 style="font-weight: 300; font-size: 1rem; width: 85%; color: red !important;" class="text-center delete-text mt-2 text-primary">{{ 'record.download.actionCannotBeUndone' | translate }}</h5>
            </div>
        </div>
    </div>
    <div class="px-4 py-3 d-flex" style="margin: 0 auto; gap: 1rem;">
        <button class="btn btn-sm btn-primary password" (click)="save()">{{ 'confirm' | translate }}</button>
        <button class="btn btn-sm btn-outline password" (click)="cancel()">{{ 'cancel' | translate }}</button>
    </div>
</div>
</div>

<div *ngIf="isResetPassword" class="modal-dialog modal-dialog-centered" style="padding: 1rem 0;">
    <div class="modal-content justify-content-center">
        <div class="modal-body modal-password">
            <div class="user-profile" style="margin-top: 0 !important;">
                <img class="logo-img" src="assets/images/warning.png" alt="avatar">
            </div>
            <div class="add-contact-box">
                <div class="add-contact-content d-flex flex-column justify-content-center align-items-center">
                    <h5 class="text-center" style="font-weight: 600;">{{ 'confirmMessage' | translate }}</h5>
                    <h5 style="font-weight: 300; font-size: 1rem; width: 85%;" class="text-center mt-2 text-primary">{{ 'resetPassword' | translate : {email:user.email} }}</h5>
                </div>
            </div>
        </div>
        <div class="px-4 py-3 d-flex" style="margin: 0 auto; gap: 1rem;">
            <button class="btn btn-sm btn-primary password" (click)="save()">{{ 'confirm' | translate }}</button>
            <button class="btn btn-sm btn-outline password" (click)="cancel()">{{ 'cancel' | translate }}</button>
        </div>
    </div>
</div>


<div *ngIf="isDeleteUser && !isConfirmAction" class="modal-dialog modal-dialog-centered" style="padding: 1rem 0;">
    <div class="modal-content justify-content-center">
        <div class="modal-body modal-password">
            <div class="user-profile" style="margin-top: 0 !important;">
                <img class="logo-img" src="assets/images/warning.png" alt="avatar">
            </div>
            <div class="add-contact-box">
                <div class="add-contact-content d-flex flex-column justify-content-center align-items-center">
                    <h5 class="text-center" style="font-weight: 600;">{{ 'confirmMessage' | translate }}</h5>
                    <h5 style="font-weight: 300; font-size: 1rem; width: 85%;" class="text-center delete-text mt-2 text-primary">{{ 'deleteUser' | translate : {name:user.userName} }}</h5>
                </div>
            </div>
        </div>
        <div class="px-4 py-3 d-flex" style="margin: 0 auto; gap: 1rem;">
            <button class="btn btn-sm btn-primary password" (click)="save()">{{ 'confirm' | translate }}</button>
            <button class="btn btn-sm btn-outline password" (click)="cancel()">{{ 'cancel' | translate }}</button>
        </div>
    </div>
</div>

<div *ngIf="isConfirmAction" class="modal-dialog modal-dialog-centered" style="padding: 1rem 0;">
    <div class="modal-content justify-content-center">
        <div class="modal-body modal-password">
            <div class="user-profile" style="margin-top: 0 !important;">
                <img class="logo-img" src="assets/images/warning.png" alt="avatar">
            </div>
            <div class="add-contact-box">
                <div class="add-contact-content d-flex flex-column justify-content-center align-items-center">
                    <h5 class="text-center" style="font-weight: 600;">{{ 'confirmMessage' | translate }}</h5>
                    <h5 style="font-weight: 300; font-size: 1rem; width: 85%;" class="text-center delete-text mt-2 text-primary">{{ 'home.sync1' | translate }}</h5>
                    <h5 style="font-weight: 300; font-size: 1rem; width: 85%;" class="text-center delete-text mt-2 text-primary">{{ 'home.sync2' | translate }}</h5>
                </div>
            </div>
        </div>
        <div class="px-4 py-3 d-flex" style="margin: 0 auto; gap: 1rem;">
            <button class="btn btn-sm btn-primary password" (click)="save()">{{ 'confirm' | translate }}</button>
            <button class="btn btn-sm btn-outline password" (click)="cancel()">{{ 'cancel' | translate }}</button>
        </div>
    </div>
</div>

